module.exports = __webpack_public_path__ + "static/scale-model-of-yellowstone-county-museum-in-billings-montana-8870842805000902bde92d2118ec7687.png";